import { Badge } from '@/components/ui/badge'
import { APPLY_TYPE, APPLY_TYPE_LABELS, REFUND_STATUS, REFUND_STATUS_LABELS } from '@/schemas/supplier'
import { cn } from '@/lib/utils'

// 申请类型徽章
interface ApplyTypeBadgeProps {
  applyType: number
  className?: string
}

const applyTypeColors: Record<number, string> = {
  [APPLY_TYPE.REFUND_ONLY]: 'bg-blue-100 text-blue-800',
  [APPLY_TYPE.RETURN_REFUND]: 'bg-purple-100 text-purple-800',
  [APPLY_TYPE.STORE_RETURN]: 'bg-cyan-100 text-cyan-800',
  [APPLY_TYPE.PLATFORM]: 'bg-orange-100 text-orange-800',
}

export function ApplyTypeBadge({ applyType, className }: ApplyTypeBadgeProps) {
  const label = APPLY_TYPE_LABELS[applyType] || '未知类型'
  const colorClass = applyTypeColors[applyType] || 'bg-gray-100 text-gray-600'

  return (
    <Badge
      variant="outline"
      className={cn(colorClass, 'border-0 font-normal', className)}
    >
      {label}
    </Badge>
  )
}

// 退款状态徽章
interface RefundStatusBadgeProps {
  refundStatus: number  // 使用 refund_type 的值
  className?: string
}

const refundStatusColors: Record<number, string> = {
  [REFUND_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800',      // 待处理
  [REFUND_STATUS.REJECTED]: 'bg-red-100 text-red-800',           // 已拒绝
  [REFUND_STATUS.AGREE_RETURN]: 'bg-blue-100 text-blue-800',     // 同意退货
  [REFUND_STATUS.RETURNED]: 'bg-cyan-100 text-cyan-800',         // 已退货
  [REFUND_STATUS.REFUNDED]: 'bg-green-100 text-green-800',       // 已退款
}

export function RefundStatusBadge({ refundStatus, className }: RefundStatusBadgeProps) {
  const label = REFUND_STATUS_LABELS[refundStatus] || '未知状态'
  const colorClass = refundStatusColors[refundStatus] || 'bg-gray-100 text-gray-600'

  return (
    <Badge
      variant="outline"
      className={cn(colorClass, 'border-0 font-normal', className)}
    >
      {label}
    </Badge>
  )
}
